import React, { useState, useEffect } from 'react';
import { Link as ScrollLink } from "react-scroll";
import styles from './NavBarNew.module.css';
import logo from "../../images/המשרד לוגו.png";
import { FaTimes, FaPhone } from 'react-icons/fa';

const NavBarNew = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const toggleMenu = () => {
    if (isMenuOpen) {
      setIsClosing(true);
      setTimeout(() => {
        setIsMenuOpen(false);
        setIsClosing(false);
      }, 500);
    } else {
      setIsMenuOpen(true);
    }
  };

  const phoneNumber = "972508919747";

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("היי המשרד הגעתי מהדף נחיתה שלכן, אשמח לשמוע עוד על השירותים שלכן");
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  };

  const navLinks = [
    { to: "שירותי המשרד", label: "שירותי המשרד" },
    { to: "בין לקוחותינו", label: "בין לקוחותינו" },
    { to: "מה אומרים עלינו", label: "מה אומרים עלינו" },
    { to: "מי אנחנו", label: "מי אנחנו" },
  ];

  return (
    <nav className={styles.navbar}>
      <div className={styles.navbarInner}>
        
        {/* צד שמאל - כפתור טלפון */}
        <div className={styles.leftSection}>
          <a href={`tel:${phoneNumber}`} className={styles.phoneButton}>
            <FaPhone className={styles.phoneIcon} />
            <span className={styles.phoneText}>חייגו אלינו</span>
          </a>
        </div>

        {/* מרכז - לוגו */}
        <div className={styles.logo}>
          <img src={logo} alt="Logo" />
        </div>
        
        {/* צד ימין - תפריט ניווט והמבורגר */}
        <div className={styles.rightSection}>
          <div className={styles.navLinks}>
            {navLinks.map((link, index) => (
              <ScrollLink
                key={index}
                to={link.to}
                smooth={true}
                duration={500}
                className={styles.navLink}
                activeClass={styles.activeLink}
                spy={true}
                offset={-100}
              >
                {link.label}
              </ScrollLink>
            ))}
          </div>

          <button className={styles.menuButton} onClick={toggleMenu}>
            <span className={styles.menuIcon}>☰</span>
          </button>
        </div>
      </div>

      {/* תפריט מובייל - נשאר ללא שינוי מבחינת לוגיקה */}
      {(isMenuOpen || isClosing) && (
        <div className={`${styles.mobileMenu} ${isClosing ? styles.closing : ''}`}>
          <div className={styles.mobileMenuHeader}>
            <div className={styles.closeButton} onClick={toggleMenu}>
              <FaTimes />
            </div>
            <div className={styles.mobileMenuLogo}>
              <img src={logo} alt="לוגו"/>
            </div>
          </div>
          <div className={styles.mobileMenuContent}>
            {navLinks.map((link, index) => (
              <ScrollLink
                key={index}
                to={link.to}
                smooth={true}
                duration={700}
                offset={-100}
                onClick={toggleMenu}
                className={styles.mobileNavLink}
              >
                {link.label}
              </ScrollLink>
            ))}
            <a href={`tel:${phoneNumber}`} className={styles.mobileConsultationButton}>
              לשיחת ייעוץ טלפונית
            </a>
            <button className={styles.mobileWhatsappButton} onClick={handleWhatsAppClick}>
              שלחו לנו וואטסאפ
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default NavBarNew;